const SERVER_SCOPE_DIMS = ['department', 'location', 'city', 'country', 'state', 'company', 'adGroup', 'user', 'tenancy'];

const norm = (v) => (v == null ? undefined : Array.isArray(v) ? (v.length ? v : undefined) : [v]);

export function toServerScope(scope) {
    const s = scope || {};
    const out = {};
    for (const dim of SERVER_SCOPE_DIMS) {
        const v = norm(s[dim]);
        if (v) out[dim] = v;
    }
    return Object.keys(out).length ? out : undefined;
}

export function hasTenancyScope(scope) {
    return !!norm(scope?.tenancy);
}

export function serverRowsOrNull(rows, scope) {
    if (!Array.isArray(rows)) return null;
    return rows.length || hasTenancyScope(scope) ? rows : null;
}
